import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface Props {
  variant?: boolean;
  className?: string;
  loading: boolean;
}

const PropertyCardSkeleton: React.FC<Props> = ({ loading }) => {
  if (!loading) {
    return null;
  }
  return (
    <div className="py-4 h-auto wrapper">
      <div className="grid-container">
        <div className="first flex flex-col">
          <Skeleton width={300} />
          <Skeleton width={400} height={30} />
          <Skeleton width={400} />
        </div>
        <div className="second flex flex-col items-end justify-end">
          <Skeleton width={300} height={30} />
          <Skeleton width={300} />
          <Skeleton width={300} />
        </div>
      </div>

      <div className="images gap-4 h-[60vh]  w-full flex">
        <Skeleton className="rounded-xl" height={"100%"} width={"50vw"} />
        <div className="w-full h-full  flex flex-col gap-3">
          <Skeleton
            containerClassName="h-full basis-1/2 max-w-full"
            height={"100%"}
            width={"100%"}
          />
          <Skeleton
            height={"100%"}
            containerClassName="max-w-full basis-1/2"
            width={"100%"}
          />
        </div>
      </div>

      <div className="mt-8">
        <div className="grid-container">
          <div className="first flex gap-6 flex-col">
            <Skeleton
              className="w-full h-[300px]"
              containerClassName="w-full h-[300px]"
            />
            <Skeleton
              className="w-full h-[300px]"
              containerClassName="w-full h-[300px]"
            />
            <Skeleton
              className="w-full h-[300px]"
              containerClassName="w-full h-[300px]"
            />
          </div>
          <div className="second  flex flex-col gap-4 items-end">
            <Skeleton
              count={2}
              className="h-full"
              containerClassName="h-[60vh] w-full"
            />
            {/* <Skeleton
              className="h-full"
              containerClassName="h-[30vh] bg-red-500 w-full"
            />
            <Skeleton
              className="h-full"
              containerClassName="h-[10vh] bg-red-500 w-full"
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyCardSkeleton;
